import SEO from "../components/SEO";
import Breadcrumbs from "../components/Breadcrumbs";

export default function About() {
  return (
    <div data-testid="about-page">
      <SEO
        title="About VidaVital Medical & Medical Peptides"
        description="Medical Peptides Powered by VidaVital Medical is a premium wellness practice offering provider-directed peptide, hormone, weight, and longevity care via live video consultation."
        path="/about"
        breadcrumbs={[{ name: "About", path: "/about" }]}
      />
      <section className="vv-hero">
        <div className="vv-container py-16">
          <Breadcrumbs items={[{ name: "About", path: "/about" }]} />
          <div className="vv-hero-eyebrow mb-2">About</div>
          <h1 className="font-display text-4xl md:text-5xl">VidaVital Medical</h1>
          <p className="mt-4 text-stone-600 max-w-3xl leading-relaxed">
            VidaVital Medical is a premium wellness practice offering provider-directed peptide, hormone, weight, and longevity care. Every therapy is reviewed by a licensed clinician through a live video consultation. We do not operate a peptide storefront and we do not dispense medications without medical oversight.
          </p>
        </div>
      </section>
      <section className="vv-container py-14 grid md:grid-cols-2 gap-10">
        <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=1600&auto=format&fit=crop" alt="Healthy adult in a fitness studio" loading="lazy" className="rounded-2xl h-[420px] object-cover" />
        <div>
          <h2 className="font-display text-3xl">Our approach</h2>
          <ul className="mt-4 space-y-3 text-stone-700">
            <li>• Licensed physicians and nurse practitioners on every consultation.</li>
            <li>• Transparent regulatory and evidence disclosures on every therapy.</li>
            <li>• Self-pay pricing with no insurance interference.</li>
            <li>• Independent clinical judgment — never automatic prescriptions.</li>
          </ul>
        </div>
      </section>
    </div>
  );
}
